import { Component, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { IAppConfig } from 'src/config/app-config.model';
import { AppConfig } from 'src/config/app-config.service';
import { Language } from 'src/core/utility/enums/enums';
import LazyLoad from "vanilla-lazyload";

@Component({
  selector: 'adahi-about-project',
  templateUrl: './about-project.component.html'
})
export class AboutProjectComponent implements AfterViewInit {

 
  appSettings: IAppConfig;
  faqListingPageUrl:string;
  @ViewChild('itemBg') itemBg: ElementRef;
  
  constructor(){
    this.appSettings = AppConfig.settings;
    this.faqListingPageUrl = "/"+ Language[_spPageContextInfo.currentLanguage] +this.appSettings.faqListingPageUrl;
  }

  // createRenderElement(parentElement, name, attrs) {
  //   var el = document.createElement(name);

  //   // insertion in DOM before applying attributes doesn't work in Firefox
  //   //parentElement.appendChild(el);

  //   for (var i = 0; i < attrs.length; i += 2) {
  //     el.setAttribute(attrs[i], attrs[i + 1]);
  //   }

  //   // will work in Firefox
  //   parentElement.appendChild(el);

  //   return el;
  // }

  // renderPictureElement() {
  //   let picture = this.createRenderElement((<HTMLElement>this.itemBg.nativeElement), 'picture', ['tabindex', '-1']);

  //   this.createRenderElement(picture, 'source', ['media', '(max-width: 1199.98px)', 'srcset', '/Style%20Library/Adahi/images/Kaaba-1-mobile.jpg', 'tabindex', '-1']);

  //   this.createRenderElement(picture, 'source', ['media', '(min-width: 1200px)', 'srcset', '/Style%20Library/Adahi/images/Kaaba-1.jpg', 'tabindex', '-1']);

  //   this.createRenderElement(picture, 'img', ['src', '/Style%20Library/Adahi/images/Kaaba-1.jpg', 'class', 'home-slider__item-img', 'tabindex', '-1']);
  // }

  ngAfterViewInit() {
    // this.renderPictureElement();
    var lazyLazy = new LazyLoad({
      elements_selector: "img.lazy",
      callback_loaded: function(el) {
        (<HTMLElement>el).closest('.home-slider__item-bg').classList.remove('lazy');
      }
    });
  }

}
